/**
 * Parallax effect to use on elements...
 * 
 * 
 */

import { isInViewport, isMobile } from './../helpers.js';

export class ParallaxElements {

    constructor(els) {
        if (isMobile() === true) {
            return;
        }
        this.els = els;
        window.addEventListener('scroll', (e) => { this.applyEffect(e) });
        window.addEventListener('resize', (e) => { this.resize() });
    }
    applyEffect(e) {
        if (this.els) {
            let elDims;
            let elTop;
            let elInitialTop;
            let speed = 15;
            let direction = { label: 'top', polarity: '-', coordinate: 'Y' };
            let computed;

            for (let i = 0; i < this.els.length; i++) {
                if (!isInViewport(this.els[i])) {
                    continue;
                }
                elDims = this.els[i].getBoundingClientRect();
                elTop = elDims.top;

                elInitialTop = this.els[i].getAttribute('data-initial-top');

                if (!elInitialTop) {
                    this.els[i].setAttribute('data-initial-top', elTop);
                }

                if (this.els[i].getAttribute('data-parallax-speed')) {
                    speed = 20 / parseInt(this.els[i].getAttribute('data-parallax-speed'));
                } else {
                    speed = 20;
                }

                if (this.els[i].getAttribute('data-parallax-direction')) {
                    direction.label = this.els[i].getAttribute('data-parallax-direction');
                } else {
                    direction.label = 'top';
                }

                if (direction.label === 'top') {
                    direction.polarity = '-';
                    direction.coordinate = 'Y';
                } else if (direction.label === 'left') {
                    direction.polarity = '-';
                    direction.coordinate = 'X';
                }

                computed = (elInitialTop - elTop);

                if (computed > 1 && elInitialTop > elTop) {
                    this.els[i].style.transform = 'translate' + direction.coordinate + '(' + direction.polarity + Math.abs(computed * (speed / 100)) + 'px';
                }
            }
        }
    }

    resize() {
        for (let i = 0; i < this.els.length; i++) {
            this.els[i].removeAttribute('data-initial-top');
            this.els[i].style.transform = '';
            this.els[i].style.opacity = '';
        }
    }
}

export class ParallaxBackgrounds {

    constructor(els) {
        if (isMobile() === true) {
            return;
        }
        this.els = els;
        window.addEventListener('scroll', (e) => { this.applyEffect() });

        // init
        this.applyEffect();
    }

    applyEffect() {
        if (this.els) {
            let speed;
            for (let i = 0; i < this.els.length; i++) {
                if (this.els[i].getAttribute('data-parallax-speed')) {
                    speed = parseInt(this.els[i].getAttribute('data-parallax-speed'));
                } else {
                    speed = 10;
                }
                this.els[i].style.backgroundPosition = "center " + ((-window.pageYOffset / speed) - 250).toString() + "px";
            }
        }
    }
}